<template>
  <div class="errPage-container">
    <router-link
      to="/campaigns/new"
      class="el-button el-button--primary is-plain"
    >
      <el-icon>
        <PlusElementIcon />
      </el-icon>
      <span>Add campaign</span>
    </router-link>
    <el-row>
      <el-col :span="12">
        <h1 class="text-jumbo text-ginormous">
          There are no posted campaigns yet!
        </h1>
        On this page, you will see all your campaigns on the platform as soon as
        you will add them. Let’s add your first campaign
      </el-col>
      <el-col :span="12">
        <img :src="ewizardClap" class="some-gif" width="313" height="428" />
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'EmptyCampaignsBlock',
  setup(props, context) {
    const ewizardClap =
      'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646'

    const { isDesktop } = useResize()

    return { ewizardClap, isDesktop }
  }
})
</script>

<style lang="scss" scoped>
.errPage-container {
  width: 800px;
  max-width: 100%;
  margin: 100px auto;
  .some-gif {
    margin: 0 auto;
    display: block;
  }
  .text-jumbo {
    font-size: 30px;
    font-weight: 700;
    color: var(--el-text-color-primary);
  }
}
</style>
